var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52611",
    "data-name": "Group 52611",
    transform: "translate(-807 -4901.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_479",
    "data-name": "Ellipse 479",
    transform: "translate(807 4901.153)",
    fill: "#fff",
    stroke: "#93a750",
    strokeWidth: 1,
    strokeDasharray: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    cx: 32.5,
    cy: 32,
    rx: 32.5,
    ry: 32,
    transform: "translate(812 4907.153)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46877",
    "data-name": "Group 46877",
    transform: "translate(652 8008.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message",
    transform: "translate(181.361 -3078.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    d: "M13.357,0,8.321,4.055a2.625,2.625,0,0,1-3.242,0L0,0",
    transform: "translate(4.668 6.566)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_511",
    d: "M5.771,0H16.9a5.852,5.852,0,0,1,4.227,1.877A5.923,5.923,0,0,1,22.694,6.25v7.707a5.923,5.923,0,0,1-1.565,4.373A5.852,5.852,0,0,1,16.9,20.208H5.771C2.323,20.208,0,17.4,0,13.957V6.25C0,2.8,2.323,0,5.771,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 28,
    height: 28,
    transform: "translate(179 -3083)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.7ea8d3b0ea138407b58f48bfc994785f.svg";
export { ForwardRef as ReactComponent };